import { makeStyles } from '@material-ui/core'
import { theme } from 'config/constants/theme/theme'

export const useStyles = makeStyles({
  root: {
    width: '800px',
    padding: '1rem 0',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 0'
    }
  }
})
